export default {
  pageText: '保证金流水',
  titleText: '保证金流水',

  // tb columns
  columnsId: 'ID',
  columnsChangeData: '变更日期',
  columnsAmount: '金额',
  columnsUnit: '单位',
  columnsDirection: '方向',
  columnsBalanceBeforeChange: '变化前余额',
  columnsBalanceAfterChange: '变化后余额',
  columnsReason: '变化原因',
  columnsSource: '关联源',

  credit: '缴纳',
  punishment: '处罚',
  AfterSalesDeduction: '售后减除',
  return: '返还',

  // search
  changeDirection: '变化方向',
  direction: {
    all: '所有',
    outlay: '支出',
    credit: '入账'
  }
}
